export default __webpack_public_path__ + "assets/home.6aba40a326889aa3cb562652513d10aa.png";